import React from "react"
export function TaEmpty(props) {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <g
        id="prefix__Page-1"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__ta-empty">
          <path
            d="M1.642 8.017c0-3.47 2.891-6.362 6.361-6.362 3.47 0 6.362 2.892 6.362 6.362s-2.892 6.361-6.362 6.361-6.361-2.795-6.361-6.361"
            id="prefix__Fill-22-path"
            fill="#FFF"
          />
          <g id="prefix__Group-3" fill="#00A680" fillRule="nonzero">
            <path
              d="M1.642 8.017c0-3.47 2.891-6.362 6.361-6.362 3.47 0 6.362 2.892 6.362 6.362s-2.892 6.361-6.362 6.361-6.361-2.795-6.361-6.361M0 8c0 4.434 3.566 8 8 8s8-3.566 8-8-3.566-8-8-8C3.566.096 0 3.663 0 8"
              id="prefix__Fill-22"
            />
          </g>
          <path
            d="M1.642 8.017c0-3.47 2.891-6.362 6.361-6.362 3.47 0 6.362 2.892 6.362 6.362s-2.892 6.361-6.362 6.361-6.361-2.795-6.361-6.361"
            id="prefix__Fill-22-path"
            fill="#FFF"
          />
        </g>
      </g>
    </svg>
  )
}
